import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetReturnChange = createAsyncThunk<AxiosResponse<any, any>, any>(
  "Return-Change/toGetReturnChange",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/return-change?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
